export const isAudioMessage = (message) => {
  const type = String(message?.type || "")
    .trim()
    .toUpperCase();
  const mime = String(message?.file_type || message?.fileType || "")
    .trim()
    .toLowerCase();
  if (type === "AUDIO" || type === "VOICE" || mime.startsWith("audio"))
    return true;
  if (["IMAGE", "VIDEO"].includes(type) || /^(image|video)/.test(mime))
    return false;
  // Legacy uploads can be labelled FILE/DOCUMENT with a generic MIME type or
  // a shortened display name. Inspect the stored URL as well as that name.
  const files = [
    message?.file_name,
    message?.fileName,
    message?.filename,
    message?.file_url,
    message?.fileUrl,
  ]
    .filter(Boolean)
    .map((value) => {
      const path = String(value).split(/[?#]/)[0];
      try {
        return decodeURIComponent(path).trim();
      } catch {
        return path.trim();
      }
    });
  if (
    files.some((file) =>
      /\.(mp3|m4a|aac|wav|ogg|oga|opus|flac|amr)$/i.test(file),
    )
  )
    return true;
  const isRecording =
    files.some((file) => /voice[-_ ]?(message|note)/i.test(file)) ||
    /^voice message$/i.test(
      String(message?.content || message?.text || "").trim(),
    );
  return isRecording && files.some((file) => /\.webm$/i.test(file));
};
